import React from 'react'
import imageOne from "../../resource/meditate/internalRetreats/itemToBring/1.png";
import imageThree from "../../resource/meditate/external-retreat/rules and regulations/2.png";


const ItemsToBring = () => {
  return (
    <div className="itemtobring-page inside-pages dark-gold">
    <div className="right-box">
      <img
        src={imageOne}
        alt="Right Top Image"
        className="right-image"
        width={300}
      />
    </div>

    <h1 className="mt-4 dark-gold font-main p-4">Essential Items to Bring during a Retreat</h1>
    
    <div className="p-4 mt-5">
      <p className="h4 mt-6">
      A bed, mattress, and pillow are provided. However, please bring the following items:
      </p>

      <p className="h4 mt-5 ">
        &#x2022;<span className="dark-gold text-bold"> Bedding</span>{" "}
        Bring your own bed linen, pillowcase, blanket, quilt, or any other bedding items you may need.
      </p>
      <p className="h4 mt-5 ">
        <span className="dark-gold text-bold"> Note</span>{" "}
        If you are from the state of Victoria, please bring the above items. For interstate or overseas visitors, bed linen will be provided.
      </p>
      <p className="h4 mt-5 ">
        &#x2022;<span className="dark-gold text-bold"> Warm Clothing</span>{" "}
        As this region can be cool, please bring warm clothing such as jackets, socks, beanies, etc.
      </p><p className="h4 mt-5 ">
        &#x2022;<span className="dark-gold text-bold"> Personal Items</span>{" "}
        Please bring your own towel, toiletries, personal hygiene items, and any personal medications.
      </p><p className="h4 mt-5 ">
        &#x2022;<span className="dark-gold text-bold"> Clothing for the Retreat</span>{" "}
        It is important to bring enough clothing for the entire retreat period, as washing facilities are limited. White or light-colored clothing is recommended.
      </p>


      <h1 className="mt-6 dark-gold font-second">
      Optional Items to Consider Bringing:
      </h1>
      <p className="h4 mt-5 ">
        &#x2022; Raincoat / Umbrella
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Hot water bottle (for warmth in bed)
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Slippers and warm shoes
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Small blanket or wrap for use in the hall
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Drinking water bottle or vacuum flask
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Torch and alarm clock
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Personal medication
      </p>


      <h1 className="mt-6 dark-gold font-second">
      Meditation Cushions
      </h1>
      <p className="h4 mt-5 ">
      Meditation cushions are available in the meditation hall, but you are welcome to bring your own if preferred. For participants who find sitting on cushions difficult, chairs are also available.
      </p>

     </div>

    <div className="bottom-box mt-6">
      <img src={imageThree} alt="bottom-image" width={400} />
    </div>
  </div>
  )
}

export default ItemsToBring